<script>
    export default {
        props: {
            post: {
                type: Object,
                default: () => {}
            },
            type: {
                type: String,
                default: 'post'
            }
        }
    };
</script>

<template>
    <div class="card shadow-none post-box">
        <div class="card-body p-2">
            <div class="media">

                <a v-if="post.permalink" :href="post.permalink" target="_blank" class="media-body font-weight-bold text-dark">
                  <span v-if="post.social_network ==='instagram'">@</span>
                  {{ post.username }}
                </a>
                <div v-else class="media-body font-weight-bold">
                    <span v-if="post.social_network ==='instagram'">@</span>
                    {{ post.username }}
                </div>

                <div class="icon-wrap">
                    <img v-if="post.social_network === 'instagram'" src="@/assets/images/brands/instagram.png" class="img-fluid" alt="">
                    <img v-if="post.social_network === 'facebook'" src="@/assets/images/brands/facebook.png" class="img-fluid" alt="">
                    <img v-if="post.social_network === 'youtube'" src="@/assets/images/brands/youtube.png" class="img-fluid" alt="">
                </div>
            </div>
        </div>

        <div class="img-bg-container">
            <img :src="post.media_url" alt="" class="img-fluid">
        </div>

        <div v-if="type === 'scheduled'" class="card-body">
            <div class="plan-features">
                <p class="font-weight-bold">
                    {{ post.campaign_name }}
                </p>
                <div class="row">
                    <div class="col-6">
                        <p class="text-muted mb-1">Date:</p>
                        <h6>{{ new Date(post.publish_date).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) }}</h6>
                    </div>
                    <div class="col-6">
                        <p v-if="post.external_post_id" class="text-muted mb-1">ID:</p>
                        <h6 v-if="post.external_post_id" class="mb-0">{{ post.external_post_id }}</h6>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="type === 'post'" class="card-body">
            <div class="row">
                <div v-for="(metrics, key) in post.metrics" :key="key" class="col-6">
                    <p class="text-muted mb-1">{{ $t(key.charAt(0).toUpperCase() + key.slice(1))}}</p>
                    <h5 class="mb-0">{{ metrics.toLocaleString() }}</h5>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
   .img-bg-container {
       display: flex;
       align-items:center;
       min-height:200px;
       background-color: #dce7f1;
   }
   .img-bg-container img {
       max-height: 200px;
       margin: auto;
   }
    .icon-wrap {
        height: 20px;
        width: 20px;
    }
</style>
